import React from 'react';

const Stats = () => {
  return (
    <section className="stats" id="stats">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Thống kê dự án</h2>
          <p className="section-description">
            Những con số đơn giản thể hiện quá trình phát triển dự án DIY
          </p>
        </div>
        <div className="stats-grid">
          <div className="stat-card glass">
            <span className="material-icons">code</span>
            <div className="stat-number">5000+</div>
            <div className="stat-label">Dòng code Arduino</div>
          </div>
          <div className="stat-card glass">
            <span className="material-icons">schedule</span>
            <div className="stat-number">300+</div>
            <div className="stat-label">Giờ phát triển</div>
          </div>
          <div className="stat-card glass">
            <span className="material-icons">memory</span>
            <div className="stat-number">ESP32-S3</div>
            <div className="stat-label">Vi điều khiển</div>
          </div>
          <div className="stat-card glass">
            <span className="material-icons">build</span>
            <div className="stat-number">PlatformIO</div>
            <div className="stat-label">IDE sử dụng</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
